import { useEffect, useState } from 'react';
import { 
    Button,
    Form,
    Alert,
    Spinner 
} from 'react-bootstrap';
import { User as UserAPI } from '../../api';
import languageManager from '../../helpers/Language';
import './UserInformation.scss';

const UpdateEmailForm = ({
    profile
}) => {
    const user = profile;
    const [initialized, setInitialized] = useState(false);
    const [updatedEmail, setUpdatedEmail] = useState(user.email);
    const [updateEmailToken, setUpdateEmailToken] = useState(null);
    const [updateEmailError, setUpdateEmailError] = useState(null);
    const [isUpdateEmailSubmitting, setIsUpdateEmailSubmitting] = useState(false);

    const handleEmailUpdate = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsUpdateEmailSubmitting(true);

        try {
            const res = await UserAPI.changeMyEmailAddress(updatedEmail);
            let message = languageManager.T('SETTINGS_ACCESS_INFO_UPDATE_EMAIL_SENT');
            if (res.skipConfirmation) {
                message = languageManager.T('SETTINGS_ACCESS_INFO_UPDATE_EMAIL_UPDATED');
            }
            setIsUpdateEmailSubmitting(false);
            setUpdateEmailError({error: false, message: message});
        } catch (err) {
            const message = err?.response?.data?.information ?? "Can't update user email, try again later.";
            setIsUpdateEmailSubmitting(false);
            setUpdateEmailError({error: true, message: message});
        }
    };

    const onEmailChange = (event) => {
        const { value } = event.target;
        setUpdatedEmail(value);
    };

    const onAlertClose = () => {
        setUpdateEmailError(null);
    }

    const emailIsIdentical = (profile.email === updatedEmail);

    useEffect(() => {
        const init = async () => {
            try {
                const currentToken = await UserAPI.getUpdateEmailToken(user.userId);
                setUpdateEmailToken(currentToken);
                setInitialized(true);
            } catch (err) {
                console.log(err);
            }
        }
        
        if (!initialized) {
            init();
        }
    }, [user, initialized, updateEmailToken]);

    return (
        <>
            {updateEmailError !== null && (
                <Alert 
                    variant={updateEmailError.error ? 'danger' : 'success'}
                    className='text-center'
                    onClose={onAlertClose}
                    dismissible
                >
                    {updateEmailError.message}
                </Alert>
            )}
            {(updateEmailToken !== null) && (
                <Alert 
                    variant={'info'}
                    className='text-center'
                >
                    {languageManager.T('SETTINGS_ACCESS_INFO_UPDATE_EMAIL_EXISTS')}:<br />
                    <strong>{updateEmailToken?.updatedEmail ?? ''}</strong>
                </Alert>
            )}
            <Form onSubmit={handleEmailUpdate}>
                <Form.Group className="mb-3" controlId="formPlaintextEmail">
                    <Form.Control 
                        type="email"
                        value={updatedEmail}
                        onChange={onEmailChange}
                        disabled={!!updateEmailToken}
                    />
                </Form.Group>
                <Button 
                    disabled={emailIsIdentical || !!updateEmailToken}
                    variant="primary" 
                    type="submit" 
                    onClick={handleEmailUpdate}
                >
                    {isUpdateEmailSubmitting ?
                        (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className='me-2'
                                />
                                Updating...
                            </>
                        ) : 
                        (
                            <>Update</>
                        )
                    }
                </Button>
            </Form>
        </>
    );
};

export default UpdateEmailForm;
